import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#050508] py-12 border-t border-white/5" data-id="element-124">
      <div className="container mx-auto px-6" data-id="element-125">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-126">
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/wwrePDBPWqppwukFQGcq8H/logo_kinetic_.png" alt="Kinetic Growth Studio Logo" className="h-8 object-contain opacity-80 hover:opacity-100 transition-opacity" data-id="element-128" />
            <p className="text-gray-500 text-sm text-center md:text-left max-w-xs" data-id="element-129">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="flex gap-6 text-sm text-gray-500" data-id="element-130">
            <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-131">
              {t('footer.terms')}
            </a>
            <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-132">
              {t('footer.privacy')}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center text-gray-600 text-sm" data-id="element-133">
          <p data-id="element-134">
            &copy; {new Date().getFullYear()} Kinetic Growth Studio.{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}